import { useTranslation } from "react-i18next";
import { ChevronRight } from "lucide-react";
import { useAuthModal } from "@/components/auth/AuthModalContext";
import { GoogleLogo, AppleLogo } from "@/components/ui/brand-icons";
import { useFeatureFlag } from "@/hooks/useFeatureFlags";
import { browserAuthReturnPath } from "@/lib/safeRedirect";
import { rememberCheckoutFlowForPostAuthClaim } from "@/lib/checkout-state";

/** Secondary, explicit alternatives; never discover accounts from an email. */
export function CheckoutSignInOptions({ flowId, email, disabled }: {
  flowId: string;
  email?: string;
  disabled: boolean;
}) {
  const { t } = useTranslation();
  const modal = useAuthModal();
  const legacy = useFeatureFlag("feature_apple_google_signin");
  const google = useFeatureFlag("feature_google_signin") || legacy;
  const apple = useFeatureFlag("feature_apple_signin") || legacy;
  return <div className="mt-5">
    <button type="button" disabled={disabled}
      className="relative flex min-h-12 w-full items-center justify-center gap-3 rounded-xl border border-foreground/25 bg-background px-12 py-3 text-sm font-semibold text-foreground transition-colors hover:border-foreground/60 hover:bg-muted/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
      aria-haspopup="dialog" onClick={() => {
        rememberCheckoutFlowForPostAuthClaim(flowId);
        modal.open({
          intent: "signin", initialStep: "email", prefilledEmail: email?.trim().toLowerCase() || "",
          next: browserAuthReturnPath(window.location, import.meta.env.BASE_URL), context: "reserve-car",
        });
      }}>
      {(apple || google) && <span className="flex shrink-0 items-center gap-1.5" aria-hidden="true">
        {apple && <AppleLogo className="h-[18px] w-[18px]" />}
        {google && <GoogleLogo className="h-[18px] w-[18px]" />}
      </span>}
      <span className="text-center">{t("checkout.identity.sign_in")}</span>
      <ChevronRight aria-hidden="true" className="absolute right-4 h-4 w-4 shrink-0 text-muted-foreground" />
    </button>
  </div>;
}
